import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import NavbarSidebarButton from './NavbarSidebarButton.view';
import NavbarProfile from './NavbarProfile.view';
import { Button } from '../../components';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import { withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { connect } from 'react-redux';
class Navbar extends PureComponent {
  render() {
    const { changeMobileSidebarVisibility, changeSidebarVisibility, history, changeActiveSidebarItem } = this.props;

    return (
      <div className='topbar'>
        <div className='topbar__wrapper'>
          <div className='topbar__left'>
            <NavbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
            <Link className='topbar__logo' to='/dashboard_default' />

            <Button
              color='secondary'
              outlined
              className='btn-xs-block mr-0'
              style={{ margin: 'auto 0px' }}
              onClick={() => {
                history.push('/help');
                changeActiveSidebarItem('/help');
              }}
            >
              Besoin d'aide
              <HelpOutlineOutlinedIcon className='ml-1' />
            </Button>

          </div>
          <div className='topbar__right'>
            <NavbarProfile />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(null, actions)(Navbar));
